/// <reference types="@progress/kendo-ui" />
var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';

var KendoBaseComponent = function (_super) {
  __extends(KendoBaseComponent, _super);

  function KendoBaseComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  KendoBaseComponent.prototype.componentDidMount = function () {
    this.exposeWidget();
    this.overrideDestroy();
  };

  KendoBaseComponent.prototype.componentWillUnmount = function () {
    if (!this.destroyed) {
      this.widgetDestroy.call(this.widgetInstance);
    }

    this.exposeWidget();
  };

  KendoBaseComponent.prototype.exposeWidget = function () {
    if (this.props.widgetRef && typeof this.props.widgetRef === 'function') {
      this.props.widgetRef(this.widgetInstance);
    }
  };

  KendoBaseComponent.prototype.overrideDestroy = function () {
    var _this = this;

    this.widgetDestroy = this.widgetInstance.destroy;

    this.widgetInstance.destroy = function () {
      _this.destroyed = !_this.destroyed;

      _this.widgetDestroy.call(_this.widgetInstance);
    };
  };

  return KendoBaseComponent;
}(React.PureComponent);

export default KendoBaseComponent;